import React from 'react';
import { Card } from '../ui/Card';
import { cn } from '../ui/Button';
import { useTheme } from '../../hooks/useTheme';
import type { OverlayType } from '../../pages/MapView';
interface TemperatureLegendProps {
  overlay: OverlayType;
}
export function TemperatureLegend({
  overlay
}: TemperatureLegendProps) {
  const {
    theme
  } = useTheme();
  const isLight = theme === 'light';
  return <Card className={cn('absolute bottom-24 right-6 z-[1000] p-3 w-[320px] backdrop-blur border', isLight ? 'bg-white/90 border-slate-200 shadow-lg shadow-slate-200/50' : 'bg-[#111827]/90 border-slate-700/50')} data-id="element-1019">
      <div className="flex items-center justify-between mb-2" data-id="element-1020">
        <span className={cn('text-xs font-semibold', isLight ? 'text-slate-800' : 'text-white')} data-id="element-1021">
          {overlay.name} [{overlay.unit}]
        </span>
      </div>

      {/* Gradient Bar */}
      <div className="h-2 w-full rounded-full mb-1" style={{
      background: overlay.gradient
    }} data-id="element-1022" />

      {/* Labels */}
      <div className={cn('flex justify-between text-[10px] font-medium px-1', isLight ? 'text-slate-500' : 'text-slate-400')} data-id="element-1023">
        {overlay.labels.map((label, i) => <span key={i} data-id="element-1024">{label}</span>)}
      </div>
    </Card>;
}